import React, { useState, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { isNil } from 'lodash';

const defaultMaskOptions = {
  prefix: '$',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowDecimal: true,
  decimalSymbol: '.',
  decimalLimit: 2,
  integerLimit: 15,
  allowNegative: false,
  allowLeadingZeroes: true,
};
function CurrencyField({
  className = '',
  fieldId,
  label,
  placeholder,
  value,
  onChange,
  touched,
  required,
  disabled = false,
  error,
}) {
  const [fieldTouched, setFieldTouched] = useState(touched || false);

  const errors = useMemo(() => {
    if ((isNil(value) || value === '') && required) {
      return `Required`;
    }
    if (value < 0) {
      return 'Invalid value';
    }
  }, [required, value]);

  const currencyMask = useMemo(
    () =>
      createNumberMask({
        ...defaultMaskOptions,
      }),
    []
  );

  return (
    <React.Fragment>
      <Form.Group className={classNames('py-2', className)}>
        {label && <Form.Label htmlFor={fieldId}>{label + (required ? '*' : '')}</Form.Label>}
        <MaskedInput
          id={fieldId}
          className={classNames('form-control', {
            'is-invalid': (fieldTouched && errors) || !!error,
          })}
          mask={currencyMask}
          placeholder={placeholder}
          value={value ?? ''}
          onChange={(e) => {
            setFieldTouched(true);
            onChange({
              field: fieldId,
              value: +e.target.value.replaceAll('$', '').replaceAll(',', ''),
              errors: errors,
            });
          }}
          disabled={disabled}
        />
        {fieldTouched && errors && (
          <Form.Text className='error form-hint fw-bold text-end m-0 mb-2'>{errors}</Form.Text>
        )}
      </Form.Group>
    </React.Fragment>
  );
}

CurrencyField.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  fieldId: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  touched: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CurrencyField;
